import { memo } from 'react';
import { Outlet } from 'react-router-dom';

const NormalLayout = () => {
  return (
    <div className="h-full flex flex-col justify-center items-center overflow-hidden">
      <Outlet />
    </div>
  );
};

export default memo(NormalLayout);
